import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addBulkUser, addSingleUser, changeSingleUserStatus, deleteSingleUser, updateSingleUser, userList } from "../apis/apiHandler";

export const users = createAsyncThunk(
    "users/list",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await userList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const addUser = createAsyncThunk(
    "users/add",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await addSingleUser(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const bulkUser = createAsyncThunk(
    "users/addBulk",
    async (payload , { rejectWithValue }) => {
        try {
            const response = await addBulkUser(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const updateUser = createAsyncThunk(
    "users/update",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await updateSingleUser(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const deleteUser = createAsyncThunk(
    "users/delete",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await deleteSingleUser(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const changeUserStatus = createAsyncThunk(
    "users/changeStatus",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await changeSingleUserStatus(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const initialState = {
    loading: false,
    userList: [],
    addUserData: {},
    updateUserData: {},
    deleteUserData: {},
    changeUserStatusData: {},
    error: null,
    success: false,
};

const userSlice = createSlice({
    name: "users",
    initialState,

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(users.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(users.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.userList = payload;
                state.success = true;
            })
            .addCase(users.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(addUser.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(addUser.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.addUserData = payload;
                state.success = true;
            })
            .addCase(addUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(bulkUser.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(bulkUser.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.addUserData = payload;
                state.success = true;
            })
            .addCase(bulkUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(updateUser.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(updateUser.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.updateUserData = payload;
                state.success = true;
            })
            .addCase(updateUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(deleteUser.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(deleteUser.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.deleteUserData = payload;
                state.success = true;
            })
            .addCase(deleteUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(changeUserStatus.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(changeUserStatus.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.changeUserStatusData = payload;
                state.success = true;
            })
            .addCase(changeUserStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
    },
});

export default userSlice.reducer;
